import React from 'react';
import MassHead from '../components/MassHead';
import FileInput from './FileInput';
import ItemList from '../components/ItemList';
import { connect } from 'react-redux';
import {
	getXMLfromString,
	cleanXMLString,
	insertXMLNodes
} from '../utilities';
import { updateSelectedPages, showDraftPages, showPublishedPages } from '../actions';

const mapStateToProps = (state) => ({
	exportFileContent: state.parseExportFile.exportFileContent,
	pageNodes: state.parseExportFile.pageNodes,
	selectedPageIds: state.updateSelection.selectedPageIds,
	authorNodes: state.parseExportFile.authorNodes,
	hasBeenRead: state.parseExportFile.hasBeenRead,
	isDraftShown: state.updateSelection.isDraftShown,
	isPublishedShown: state.updateSelection.isPublishedShown
})

const mapDispatchToProps = (dispatch) => ({

	onPageSelectionChange: (list) => {

		const pages = Array.from(list.querySelectorAll('li'));
		let selection = [];
		for(const page in pages) {

			if ( pages[page].classList.contains('selected') ) {

				selection.push(pages[page].getAttribute('data-id'));
			}
		}

		dispatch(updateSelectedPages(selection));
	},
	onShowDraftPages: (event) => dispatch(showDraftPages(event.target.checked)),
	onShowPublished: (event) => dispatch(showPublishedPages(event.target.checked))
})

class Page extends React.Component {

	prepareXML() {

		const { exportFileContent, pageNodes, authorNodes, selectedPageIds } = this.props;

		let newXmlDoc = getXMLfromString(cleanXMLString(exportFileContent));
		newXmlDoc = insertXMLNodes(newXmlDoc, 'channel', authorNodes);

		// INSERT MENU ITEM FILTERED NODES
		for (let node in pageNodes) {

			const postId = pageNodes[node].querySelector('post_id').textContent;

			if ( selectedPageIds.includes(postId) ) {

				newXmlDoc.getElementsByTagName('channel')[0].appendChild(pageNodes[node]);
			}
		}

		return new XMLSerializer().serializeToString(newXmlDoc);
	}

	render() {

		const { pageNodes, selectedPageIds, hasBeenRead, onPageSelectionChange, onShowDraftPages, isDraftShown, onShowPublished, isPublishedShown } = this.props;

		const file = new Blob([this.prepareXML()], {type: 'text/plain'});
		const link = URL.createObjectURL(file);

		return (

			<div className="Page">
				<MassHead hasBeenRead={hasBeenRead} />
				<FileInput />
				{ hasBeenRead ?
					<div>
						{
							selectedPageIds.length > 0 ?
								<div className='tc mt4'>
									<a
							    		href={link}
							    		download={'wp_pages_import_' + new Date().toLocaleString() + '.xml'}
							    		className='bg-brand-magenta white hover-white dib pv3 ph4 no-underline f4 pointer grow'>
							    		Download Pages Export File
										</a>
								</div>
							: ''
						}
						<ItemList
							items={pageNodes}
							selectedItems={selectedPageIds}
							onPageSelectionChange={onPageSelectionChange}
							onShowDraftPages={onShowDraftPages}
							onShowPublished={onShowPublished}
							isDraftShown={isDraftShown}
							isPublishedShown={isPublishedShown}
							/>
					</div>
					: ''
				}
			</div>
			)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
